import { __module as objectWithoutPropertiesLoose } from "../../../../_virtual/objectWithoutPropertiesLoose.js";
var hasRequiredObjectWithoutPropertiesLoose;
function requireObjectWithoutPropertiesLoose() {
  return hasRequiredObjectWithoutPropertiesLoose ? objectWithoutPropertiesLoose.exports : (hasRequiredObjectWithoutPropertiesLoose = 1, function(module) {
    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {}, sourceKeys = Object.keys(source), key, i;
      for (i = 0; i < sourceKeys.length; i++)
        key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
      return target;
    }
    module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = !0, module.exports.default = module.exports;
  }(objectWithoutPropertiesLoose), objectWithoutPropertiesLoose.exports);
}
export {
  requireObjectWithoutPropertiesLoose as __require
};
//# sourceMappingURL=objectWithoutPropertiesLoose.js.map
